import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';

import EnableDialogComponent from './EnableDialog';
import { remitPayerSelectAll, setRemitPayerEnableDialog } from '../../../store/actions/payers';
import { setV2 } from '../../../store/actions/pagesV2';

export const EnableDialog = connect(
    () => {
        const selectClaimIds = (state, props) => state.pagesV2['remit-payers-landing'].selected;
        const selectEnableDialog = (state) => state.payers.remitPayerEnableDialog;

        const selectOpen = createSelector(
            selectEnableDialog,
            (remitPayerEnableDialog) => {
                if (remitPayerEnableDialog && remitPayerEnableDialog?.open) {
                    return true
                }
                return false
            }
        );

        const selectEnabledClick = createSelector(
            selectEnableDialog,
            (remitPayerEnableDialog) => {
                if (remitPayerEnableDialog && remitPayerEnableDialog?.isEnableClicked) {
                    return true
                }
                return false
            }
        )

        return (state, props) => ({
            open: selectOpen(state),
            isEnableClicked: selectEnabledClick(state),
            selectedItems: selectClaimIds(state, props),
            selectAllStatusPending: state.payers.remitPayerSelectAll.pending,
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            setSelected: (value) => setV2('remit-payers-landing', 'selected', value),
            setRemitPayerEnableDialog: setRemitPayerEnableDialog,
            remitPayerSelectAll: remitPayerSelectAll,
        }, dispatch)
    })
)(injectIntl(EnableDialogComponent));